/** Tempo decorrido desde `desde` (ISO), atualizado a cada segundo: "45 s", "1 min 5 s". */
import { useEffect, useState } from 'react';

export function Cronometro({ desde }: { desde: string }) {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setAgora(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const s = Math.max(0, Math.round((agora - new Date(desde).getTime()) / 1000));
  return <>{s < 60 ? `${s} s` : `${Math.floor(s / 60)} min ${s % 60} s`}</>;
}
